<template>
  <div>
    <el-form-item v-for="(item, i) in dialogData.items" :key="i" :prop="item.prop" :label="item.label" :label-width="item.width">

      <el-input v-if="item.type === 'input'" :size="item.size?item.size:'medium'" v-model="form[item.prop]" :disabled='dialogData.editFlag&item.editable||item.operator' :style="item.style"/>
      <el-input-number v-else-if="item.type === 'number'" v-model="form[item.prop]" :min="item.min" :max="item.max"></el-input-number>
      <el-switch v-else-if="item.type === 'switch'" v-model="form[item.prop]" @change="switchChange" :disabled='dialogData.editFlag&item.editable'/>
      <el-date-picker v-else-if="item.type === 'date'" v-model="form[item.prop]"  type="date" value-format="yyyy-MM-dd" :style="item.style"/>
      <el-date-picker v-else-if="item.type === 'month'" v-model="form[item.prop]"  type="month" value-format="yyyy-MM" :style="item.style"/>
      <el-date-picker v-else-if="item.type === 'year'" v-model="form[item.prop]"  type="year" value-format="yyyy" :style="item.style"/>
      <el-date-picker v-else-if="item.type === 'time'" v-model="form[item.prop]"  type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :style="item.style"/>

      <el-date-picker v-else-if="item.type === 'date_range'" v-model="form[item.prop]" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
      <el-button v-else-if="item.type === 'button'" @click="item.click">{{item.name}}</el-button>

      <el-select v-else-if="item.type === 'select'" v-model="form[item.prop]" :disabled='dialogData.editFlag&item.editable' :style="item.style" size="small" @change="dealSelChange($event, item)" filterable>
        <el-option v-for="option in item.options" :key="option[item.props.value]" :value="option[item.props.value]" :label="option[item.props.label]"/>
      </el-select>

      <el-select v-else-if="item.type === 'multi_select'" v-model="form[item.prop]" multiple collapse-tags :disabled='dialogData.editFlag&item.editable' :style="item.style" size="small" filterable>
        <el-option v-for="option in item.options" :key="option[item.props.value]" :value="option[item.props.value]" :label="option[item.props.label]"/>
      </el-select>

      <el-radio-group v-else-if="item.type === 'radio'" v-model="form[item.prop]" :style="item.style" size="small">
        <el-radio v-for="option in item.options" :key="option[item.props.label]" :label="option[item.props.label]"/>
      </el-radio-group>

      <el-checkbox-group v-else-if="item.type === 'check'" v-model="form[item.prop]" :style="item.style" size="small">
        <el-checkbox v-for="option in item.options" :key="option[item.props.label]" :label="option[item.props.label]" :name="item.prop"/>
      </el-checkbox-group>

      <el-checkbox-group v-else-if="item.type === 'check-button'" v-model="form[item.prop]" :style="item.style">
        <el-checkbox-button v-for="option in item.options" :key="option[item.props.label]" :label="option[item.props.label]" :name="item.prop"/>
      </el-checkbox-group>

      <el-table v-else-if="item.type === 'table'" :data="item.tableData" :style="item.style" >
        <el-table-column type="index" label="序号" width="fit-content"/>
        <el-table-column v-for="(tItem, i) in item.tableProps" :key="i" :prop="tItem.prop" :label="tItem.label" :width="tItem.width" :sortable="tItem.sortable">
          <template slot-scope="scope">
            <span v-if="tItem.prop === 'name'"> {{scope.row[tItem.prop]}}</span>
            <span v-else-if="tItem.prop === 'code'"> {{scope.row[tItem.prop]}}</span>
            <span v-else-if="tItem.prop === 'addr'"> {{scope.row[tItem.prop]}}</span>
            <el-input v-else-if="tItem.prop === 'remark'" v-model="scope.row[tItem.prop]"> {{scope.row[tItem.prop]}}</el-input>
            <el-radio-group v-else-if="tItem.prop === 'status'" v-model="scope.row[tItem.prop]" >
              <el-radio v-for="op in tItem.options" :key="op.key" :label="op.key" :name="tItem.prop"> {{op.label}}</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>

      <el-color-picker v-else-if="item.type === 'color'" v-model="form[item.prop]" :style="item.style"></el-color-picker>
      <span v-else-if="item.type === 'label'" :style="item.style"> {{item.hasOwnProperty('alt')?(item.alt[form[item.prop]]):form[item.prop]}}</span>
      <el-row v-else-if="item.type === 'logo'">
        <el-upload ref="logoUpload"
                   class="logo-uploader"
                   action="#"
                   accept=".jpg,.png"
                   :auto-upload="false"
                   :show-file-list="false"
                   :on-change="changeLogoFile"
                   :before-upload="beforeUpload">
          <el-image v-if="logoUrl" :src="logoUrl" fit="contain" alt=""/>
          <i v-else class="zy-icon-plus logo-uploader-icon"></i>
        </el-upload>
      </el-row>
    </el-form-item>
    <el-form-item class="standard-form-bottom">
      <el-button v-on:click="closeDialog">取消</el-button>
      <el-button v-if="!dialogData.step||dialogData.step===2" type="primary" v-on:click="saveData">确定</el-button>
    </el-form-item>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "StandardForm",
  props: {
    dialogData: {
      type: Object,
      default: function () {
        return null;
      }
    },
    form: {
      type: Object,
      default: function () {
        return null;
      }
    },
    closeDialog: {
      type: Function,
      default: function () {
        return null;
      }
    },
    saveData: {
      type: Function,
      default: function () {
        return null;
      }
    }
  },
  data() {
    return {
      imageUrl: '',
      isPrint: true,
      setUrl: undefined
    }
  },
  computed: {
    logoUrl() {
      if(this.setUrl) {
        return this.setUrl
      } else if(this.form.hasLogo) {
        return axios.defaults.baseURL + '/sys/getUserIcon?id=' + this.form.id
      }
      return undefined
    }
  },
  methods: {
    switchChange(val) {
      // console.log(val);
    },
    radioCheckChange(val) {
      // console.log(this.form.isPrint)
    },
    dealSelChange(val, item) {
      if (item.hasOwnProperty('changeMethod')) {
        this.form[this.dialogData.items[item.changeIndex].prop] = ''
        item.changeMethod(val).then(res => {
          if (res.code === 200) {
            this.dialogData.items[item.changeIndex].options = res.data
          }
        })
      }
    },
    changeLogoFile(file, fileList) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过 1MB!');
      }
      this.setUrl = URL.createObjectURL(file.raw);
      this.$refs.logoUpload[0].submit();
    },
    beforeUpload(file) {
      this.form.file = file;
      return false;
    }
  }
}
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .logo-uploader .el-upload {
    width: 310px;
    height: 120px;
    border: 1px dashed #bcbcbc;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .logo-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 28px;
    line-height: 28px;
    text-align: center;
  }
</style>

<style scoped>
  .standard-form-bottom{
    width: 100%;
    text-align: right
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/CommonDialog/StandardForm.vue